<template>
  <div class="dismissed-suggestion">
    <el-form ref="rejectedForm" :model="rejectedForm" :rules="rules" class="demo-ruleForm">
      <el-dialog title="驳回意见" :visible.sync="rejectedVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500" lock-scroll>
        <div>
          <el-form-item prop="rejectedInfo">
            <el-input
              v-model="rejectedForm.rejectedInfo"
              type="textarea"
              placeholder="请输入您的驳回意见"
              maxlength="200"
              show-word-limit
              rows="6"
            />
          </el-form-item>
        </div>
        <div class="block" style="text-align: right;padding-top: 20px">
          <el-button @click="rejectedVisible=false">
            取 消
          </el-button>
          <el-button type="primary" @click="submit">
            确 定
          </el-button>
        </div>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import { insertApprovalLog } from '@/API';
import { mapState } from 'vuex';

export default {
  name: 'DismissedSuggestion',
  data () {
    return {
      rejectedVisible: false,
      rejectedForm: {
        rejectedInfo: ''
      },
      rules: {
        rejectedInfo: [
          { required: true, message: '请输入您的驳回意见', trigger: 'blur' }
        ]
      }

    };
  },
  props: {
    contractId: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    ...mapState({ userInfo: state => state.user })
  },

  methods: {
    showRejectDialog () {
      this.rejectedVisible = true;
    },
    submit () {
      this.$refs['rejectedForm'].validate((valid) => {
        if (valid) {
          this.loading = false;
          let params = {
            contractId: this.contractId,
            approvalContent: this.rejectedForm.rejectedInfo
          };
          insertApprovalLog(params).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('提交成功');
              this.rejectedVisible = false;
              this.$parent.Reject(() => {
                this.loading = false;
              });
            }
          }).catch((res) => {

          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
